<template>
    <small-dialog
        v-model="dialog"
        no-activator
        :title="dialogTitle"
        loading="registrationLinkViewer"
        noOkButton
        cancelButton="tutup"
    >
        <template v-if="! isLoading">
            <v-img :src="qr"></v-img>

            <div class="text-center">
                <code>
                    {{ displayedRegistrationLink }}
                </code>
            </div>
        </template>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'

export default {
    components: {
        SmallDialog,
    },

    data: () => ({
        dialog: false,
        viewedRegistrationLink: null,
        isLoading: true,
        qr: null,
    }),

    computed: {
        dialogTitle() {
            return this.isLoading ? `Daftar` : `Daftar ${this.viewedRegistrationLink.period.title}`
        },

        displayedRegistrationLink() {
            return ! this.isLoading ? `${process.env.VUE_APP_BASE_URL}d/${this.viewedRegistrationLink.slug}` : null
        }
    },

    methods: {
        async show(registrationLink) {
            this.dialog = true
            this.isLoading = true

            this.viewedRegistrationLink = registrationLink
            const qrCode = await this.$apiv2.get(
                `registration-link/${registrationLink.id}/qrcode`,
                {
                    responseType: 'blob'
                }
            )
            this.qr = URL.createObjectURL(qrCode.data)
            this.isLoading = false
        }
    }
}
</script>
